import { render, staticRenderFns } from "./XzkcGroup.vue?vue&type=template&id=3b2faf22&scoped=true"
import script from "./XzkcGroup.vue?vue&type=script&lang=js"
export * from "./XzkcGroup.vue?vue&type=script&lang=js"
import style0 from "./XzkcGroup.vue?vue&type=style&index=0&id=3b2faf22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2faf22",
  null
  
)

export default component.exports